// src/components/gifts/GiftCategoryRow.jsx
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import GiftCard from "./GiftCard";
import { getCategoryLabel } from "../../constants/giftCategories";

export default function GiftCategoryRow({ category, gifts, total, onOpenGift }) {
  if (!gifts || gifts.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2.5 px-0.5">
        <div className="flex items-center gap-2">
          <span className="w-1 h-4 bg-purple-600 rounded-full" />
          <h2 className="font-serif text-sm sm:text-base font-semibold text-gray-900 dark:text-white">
            {getCategoryLabel(category)}
          </h2>
        </div>
        {total > gifts.length && (
          <Link
            to={`/dashboard/gifts/category/${category}`}
            className="flex items-center gap-1 text-xs sm:text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
          >
            View all <ArrowRight size={13} />
          </Link>
        )}
      </div>

      <div className="flex gap-2.5 sm:gap-3 overflow-x-auto pb-1 snap-x snap-mandatory scrollbar-hide -mx-4 px-4 sm:mx-0 sm:px-0">
        {gifts.map((gift) => (
          <div key={gift._id} className="snap-start">
            <GiftCard gift={gift} onOpen={onOpenGift} />
          </div>
        ))}
      </div>
    </div>
  );
}